/**
 * Sérialise campagneData.config.tokens en string CSS injectée dans <Head>.
 *
 * Format attendu de `tokens` :
 *   {
 *     main: { primary, secondary, dark, text, radius },  // optionnel
 *     custom: { "donation-button-bg": "#000", ... }      // optionnel
 *   }
 *
 * Renvoie une string CSS `:root { --cp-xxx: ...; ... }` ou "" si pas de tokens.
 * Le web ne connait pas la notion de "preset" : tout est aplati côté admin
 * avant d'arriver ici.
 */

const MAIN_KEYS = ["primary", "secondary", "dark", "text", "radius"]

function sanitize(value) {
    // Garde-fou minimal contre l'injection CSS via valeurs malicieuses :
    // les couleurs / radius / linear-gradient ne contiennent jamais ";" ni "}".
    if (typeof value !== "string" && typeof value !== "number") return null
    const str = String(value)
    if (str.includes(";") || str.includes("}") || str.includes("<")) return null
    return str
}

export function buildTokensCss(tokens) {
    if (!tokens || typeof tokens !== "object") return ""

    const decls = []

    if (tokens.main && typeof tokens.main === "object") {
        for (const key of MAIN_KEYS) {
            const value = sanitize(tokens.main[key])
            if (value) {
                decls.push(`  --cp-${key}: ${value};`)
            }
        }
    }

    if (tokens.custom && typeof tokens.custom === "object") {
        for (const [key, raw] of Object.entries(tokens.custom)) {
            // Whitelist soft : la clé doit être kebab-case alphanum/tirets.
            if (!/^[a-z0-9-]+$/.test(key)) continue
            const value = sanitize(raw)
            if (value) {
                decls.push(`  --cp-${key}: ${value};`)
            }
        }
    }

    if (decls.length === 0) return ""

    return `:root {\n${decls.join("\n")}\n}`
}

/**
 * Helper côté JS pour récupérer la couleur primaire effective (Antd
 * ConfigProvider qui ne lit pas les CSS vars). Fallback chaîné :
 *   tokens.main.primary  →  config.primaryColor (legacy)  →  "#13A0BB"
 */
export function getPrimaryColor(config) {
    return (
        config?.tokens?.main?.primary ||
        config?.primaryColor ||
        "#13A0BB"
    )
}
